import { useEffect, useState } from 'react'

import Analytics from '../analytics'

import { localeStorageSet, COOKIES_KEY } from '../storage'

const useCookies = () => {
  const [show, set] = useState(false)

  useEffect(() => {
    const isAccepted = !!localStorage?.getItem(COOKIES_KEY)
    set(!isAccepted)
  }, [])

  const action = (userAction: string) => {
    if (userAction === 'accept') {
      localeStorageSet(COOKIES_KEY, 'done')
      Analytics.event.accepted_cookies_click()
    } else {
      localeStorageSet(COOKIES_KEY, 'declined')
    }

    set(false)
  }

  return { show, action }
}

export default useCookies
